<template lang="pug">
  .b2b-steps(@click='goToStep')
    el-steps(
      :active='active',
      align-center)
      el-step(
        v-for='(step, index) in steps',
        :key='index',
        :title='step.title')
</template>

<script>
import Vue from 'vue'
import { Steps, Step } from 'element-ui'
Vue.use(Steps)
Vue.use(Step)
export default {
  name: 'b2b-steps',
  props: {
    steps: {
      type: Array,
      required: true
    },
    active: {
      type: Number,
      required: true
    }
  },

  methods: {
    setActive (active) {
      this.active = active // eslint-disable-line
    },

    getCabecera () {
      this.$emit('update', 0)
    },

    getLines () {
      this.$emit('update', 1)
    },

    getTotals () {
      this.$emit('update', 2)
    },
    getStepsFour () {
      this.$emit('update', 3)
    },

    goToStep (event) {
      // Comprobamos si el evento ha detectado que pulsamos sobre el círculo o sobre el número
      if (event.target.className === 'el-step__icon is-text' || event.target.className === 'el-step__icon-inner') {
        // Comprobamos el dato que contiene el STEP para decidir hacia dónde redirigimos
        const step = event.target.className === 'el-step__icon-inner'
          ? (event.target.lastChild.data)
          : event.target.lastChild.lastChild.data
        switch (step) {
          case '1':
            this.getCabecera()
            break
          case '2':
            this.getLines()
            break
          case '3':
            this.getTotals()
            break
          case '4':
            this.getStepsFour()
            break
          default:
            break
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-steps {
  padding-top: 40px;
  padding-left: 347px;
  padding-right: 438px;
  ::v-deep .el-step{
    &__title.is-process {
      font-weight: 500;
      color: var(--color-txt-primary);
    }
    &__icon{
      cursor: pointer;
    }
  }
}
</style>
